/* Generated by scripts/build_theme.py from app/index.html — do not edit by hand. */
(function(){
'use strict';
var cfgEl=document.getElementById('ekb-config');
var EKB_CONFIG=cfgEl?JSON.parse(cfgEl.textContent):{};
var liveEl=document.getElementById('ekb-catalog-live');
var EKB_CATALOG=(liveEl&&EKB_CONFIG.catalogSource==='collection')?JSON.parse(liveEl.textContent):window.CATALOG;
var rootEl=document.getElementById('ekb-root');
if(!rootEl){console.error('[EKB] root missing');return;}
/* A CDN blip on the catalog asset used to leave a silent blank page. */
if(!EKB_CATALOG||!EKB_CATALOG.products||!EKB_CATALOG.products.length){
  console.error('[EKB] no catalog available');
  rootEl.innerHTML='<div class="ekb-fail"><b>The kit builder could not load.</b>'+
    '<span>Please refresh the page. If it keeps happening, call us and we will '+
    'build your kit with you.</span></div>';
  return;
}
/* printing must escape the theme's DOM, so the sheet lives on <body> */
(function(){var qs=document.getElementById('ekb-quotesheet');
 if(qs&&qs.parentNode!==document.body)document.body.appendChild(qs);})();
/* Keep the draft-preview toolbar and storewide marketing launchers out of
   the builder's fixed action area. This is scoped to pages containing EKB. */
(function manageStorefrontChrome(){
 var selectors=['#smile-ui-lite-container','#smile-ui-lite-launcher-frame-container',
  '#smile-ui-lite-launcher-frame','[id^=\"smile-ui-lite-launcher-frame\"]',
  '.klaviyo-form','[class*=\"klaviyo-form\"]','[id^=\"klaviyo\"]',
  '[id*=\"klaviyo-onsite\"]','[class*=\"kl-private-reset-css\"]',
  '[class*=\"needsclick\"][style*=\"position: fixed\"]','iframe[src*=\"klaviyo\"]'];
 var textSelectors=['.needsclick','[class*=\"klaviyo\"]','[class*=\"kl-private-reset-css\"]','button','[role=\"button\"]','a'];
 function hide(el){if(!el||el===rootEl||rootEl.contains(el))return;el.setAttribute('aria-hidden','true');
  el.style.setProperty('display','none','important');el.style.setProperty('visibility','hidden','important');
  el.style.setProperty('pointer-events','none','important');el.style.setProperty('opacity','0','important');}
 function overlayRoot(el){var cur=el,fallback=el;while(cur&&cur!==document.body){var cls=typeof cur.className==='string'?cur.className:'';
  if(cls.indexOf('needsclick')>-1||cls.indexOf('klaviyo')>-1||cls.indexOf('kl-private-reset-css')>-1)fallback=cur;
  var pos=getComputedStyle(cur).position;if(pos==='fixed'||pos==='sticky')return cur;cur=cur.parentElement;}return fallback;}
 function run(){rootEl.style.setProperty('--preview-bottom',document.getElementById('PBarNextFrame')?'64px':'0px');
  document.querySelectorAll(selectors.join(',')).forEach(hide);
  document.querySelectorAll(textSelectors.join(',')).forEach(function(el){var txt=(el.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
   if(txt.indexOf('unlock')>-1&&txt.indexOf('$100')>-1&&txt.indexOf('off')>-1)hide(overlayRoot(el));});}
 var queued=false;function schedule(){if(queued)return;queued=true;requestAnimationFrame(function(){queued=false;run();});}
 run();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
 window.addEventListener('resize',schedule,{passive:true});
})();

/* ============================================================
   MVP Visuals — Event Display Kit Builder
   ============================================================ */
const DATA=EKB_CATALOG, PRODUCTS=DATA.products, GROUPS=DATA.groups;
const SKU_INDEX={};
PRODUCTS.forEach(p=>p.variants.forEach(v=>{ if(v.sku) SKU_INDEX[v.sku.toUpperCase()]={p,v}; }));

/* ---------- Zones ---------- */
const ZONES=[
  {id:'structure', num:'01', label:'Shelter & Structure', helper:'Tents, walls & pipe-and-drape — the frame of your booth', core:true},
  {id:'backdrop',  num:'02', label:'Backdrops & Backwalls', helper:'Tension-fabric backdrops, step & repeat, banner stands', core:true},
  {id:'signage',   num:'03', label:'Flags & Signage', helper:'Feather, teardrop & rectangle flags for vertical reach', core:true},
  {id:'banners',   num:'04', label:'Banners', helper:'Vinyl, mesh, pole & tent banners', core:false},
  {id:'table',     num:'05', label:'Table Presence', helper:'Table covers, throws, stretch fits & podiums', core:true},
  {id:'attention', num:'06', label:'Attention-Grabbers', helper:'Inflatable arches, tunnels & mascots', core:false},
  {id:'accessories',num:'07', label:'Accessories & Logistics', helper:'Weight bags, cases, poles, coating, rush & design', core:false},
];
const ZONE_BY_ID={}; ZONES.forEach((z,i)=>{z._i=i; ZONE_BY_ID[z.id]=z;});

function zoneFor(p){
  const t=(p.type||'').toLowerCase(), g=p.group, title=p.title.toLowerCase();
  const hay=title+' '+(p.tags||[]).join(' ').toLowerCase();
  const has=(...ks)=>ks.some(k=>hay.includes(k));
  if(has('rush','shipping','design fee','vector art','coating','repellent','warranty','leg printing','printing options')) return 'accessories';
  if(has('weight bag','sandbag','carry bag','carry case','travel case','roller bag','hard case','replacement bag')) return 'accessories';
  if((title.includes('flag')&&(title.includes('pole')||title.includes('base')))||g==='Flag Accessories') return 'accessories';
  if(title.includes('awning')) return 'accessories';
  if(title.includes('podium')) return 'table';
  if(t.includes('inflatable')||has('inflatable','mascot','tunnel','buoy','dome tent')||(title.includes('arch')&&!title.includes('march'))) return 'attention';
  if(has('backdrop','step and repeat','backwall','back wall','tension fabric')) return 'backdrop';
  if(title.includes('banner stand')||title.includes('retractable')) return 'backdrop';
  if(t.includes('tent')){
    if(title.includes('flag')) return 'signage';
    if(title.includes('billboard')||title.includes('corner banner')||title.includes('valance')||title.includes('banner')) return 'banners';
    return 'structure';
  }
  if(has('pipe and drape','pipe & drape','drape','podium','counter','display package','package','canopy')) return 'structure';
  if(t.includes('table')||g==='Table Covers'||has('tablecloth','table throw','table cover','table runner')) return 'table';
  if(t.includes('flag')||g==='Flags'||has('feather flag','teardrop','flag')) return 'signage';
  if(t.includes('banner')||has('banner','vinyl','mesh')) return 'banners';
  return 'accessories';
}
PRODUCTS.forEach(p=>{p._zone=(p.zone&&ZONE_BY_ID[p.zone])?p.zone:zoneFor(p);});

/* Products kept out of the kit builder zones (pre-made bundles) — still listed under All products */
const EXCLUDE_BUILDER=new Set(['outdoor-event-display-package','indoor-event-display-package']);

/* Not customer-shoppable line items. Three of these are Globo option-set carriers
   (handles literally begin "option-set-") that exist to hold surcharges on a product
   page; the rest are services a rep quotes — art, design, rush — several of which
   depend on answers we now collect elsewhere (the event date drives rush).
   Putting any of them in a booth kit as a standalone line is a defect. */
const NOT_SHOPPABLE=new Set([
  'option-set-320898-select-1',   // Printing Options
  'option-set-320898-select-4',   // Coating Options
  'option-set-320279-select-1',   // Leg Printing Options
  'design-fee',                   // Design Fee
  'vector-recreation',            // Vector Art Recreation
  'rush-shipping-6-8-days'        // Rush Shipping
]);
const SHOPPABLE=PRODUCTS.filter(p=>!NOT_SHOPPABLE.has(p.handle));

/* ---------- Templates ---------- */
const TEMPLATES=[
  {name:'Youth sports tournament', desc:'10×10 tent, table cover, banner stand & 2 flags',
   items:[['10x10-CANOPY-WITH-FRAME',1],['8FT-POLY-THROW-CB',1],['CFM-SS-36X90-SS',1],['CFM-FL-SM-SS-GS',2]]},
  {name:'Trade show 10×10', desc:'Walls, fabric backdrop, banners & weight bags',
   items:[['10x10-CANOPY-WITH-FRAME',1],['Full-Wall-10ft-SS',2],['8FT-POLY-THROW-CB',1],['CFM-T-S-8_SS',1],
          ['CFM-FL-SM-SS-GS',2],['VNL12-1836-G',2],['WATER-WEIGHTBAGS-1',1]]},
  {name:'Race or finish line', desc:'Full booth plus an inflatable arch & extra signage',
   items:[['10x10-CANOPY-WITH-FRAME',1],['Full-Wall-10ft-SS',3],['8FT-POLY-THROW-CB',2],['CFM-T-S-8_SS',1],
          ['CFM-FL-SM-SS-GS',2],['CFM-TD-SM-SS-GS',2],['VNL12-1836-G',2],['15ft-300D-ANGLED-ARCH',1],
          ['WATER-WEIGHTBAGS-1',2]]},
];

/* ---------- State ---------- */
const LS_KEY='mvp_kit_v2';
let state={mode:'builder', query:'', group:'All', sort:'featured', density:'grid',
  sel:{}, order:[], setups:1, showAll:false, po:{reqby:'',ship:'',email:'',company:'',phone:'',eventDate:''}, submission:null};

/* RFQ transport. Shopify's native contact form owns the sales email. The shared
   Apps Script endpoint is an independent, fail-open Sheet lane, matching the six
   established RFQ widgets. Both lanes carry the same Submission ID. */
const RFQ={
  source_widget:'event_kit_builder',
  schema_version:'1.0',
  product_type:'Event Display Kit',
  nativeFormId:'ekb-contact-form',
  /* Set from the Liquid section on the storefront. Left null on the static prototype. */
  sheetEndpoint:(EKB_CONFIG.rfqEndpoint||null)
};
let expanded=new Set();
loadState();

/* ---------- Helpers ---------- */
const ROOT=document.getElementById('ekb-root');
const EXTERNAL_NODES={'#quotesheet':'ekb-quotesheet','#ekb-contact-status':'ekb-contact-status'};
const $=s=>(EXTERNAL_NODES[s]?document.getElementById(EXTERNAL_NODES[s]):ROOT.querySelector(s));
const $$=s=>Array.prototype.slice.call(ROOT.querySelectorAll(s));
const isPhone=()=>window.matchMedia('(max-width:700px)').matches;
const money=n=>'$'+n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
const money0=n=>'$'+Math.round(n).toLocaleString('en-US');
const esc=s=>(s||'').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
function toast(m){$('#toastMsg').textContent=m;const t=$('#toast');t.classList.add('show');clearTimeout(toast._t);toast._t=setTimeout(()=>t.classList.remove('show'),1900);}
function uid(){return 'l'+Math.random().toString(36).slice(2,9);}
/* The kit is worth remembering; the customer is not ours to keep. Contact fields are
   left to the browser's own autofill (the inputs carry autocomplete attributes), which
   is consented, device-scoped and not readable by the next person at a shared screen. */
function maskEmail(e){e=(e||'').trim();const at=e.indexOf('@');
  return at>1?e[0]+'•••'+e.slice(at):e;}
function sanitizeSubmission(sub){
  if(!sub)return null;
  /* The payload carries the person in several places — contact, email_body, details —
     so none of it is persisted. printQuote only needs the reference number. */
  return {id:sub.id,at:sub.at,sentLabel:sub.sentLabel,emailMasked:sub.emailMasked,
          fingerprint:sub.fingerprint};
}
function saveState(){try{localStorage.setItem(LS_KEY,JSON.stringify({order:state.order,sel:state.sel,setups:state.setups,submission:sanitizeSubmission(state.submission)}));}catch(e){}}
function loadState(){try{const s=JSON.parse(localStorage.getItem(LS_KEY)||'null');if(s){state.order=(s.order||[]).filter(l=>!NOT_SHOPPABLE.has(l.handle));state.sel=s.sel||{};state.setups=s.setups||1;state.submission=s.submission||null;}}catch(e){}}

function defaultSel(p){const s={};p.options.forEach(o=>s[o.pos]=o.values[0]);return s;}
function getSel(p){if(!state.sel[p.handle])state.sel[p.handle]=defaultSel(p);
  p.options.forEach(o=>{if(!(o.pos in state.sel[p.handle]))state.sel[p.handle][o.pos]=o.values[0];});return state.sel[p.handle];}
function matchVariant(p){const sel=getSel(p);if(!p.options.length)return p.variants[0];
  return p.variants.find(v=>p.options.every(o=>v['o'+o.pos]===sel[o.pos]))||null;}
function variantOptLabel(p,v){return p.options.map(o=>v['o'+o.pos]).filter(Boolean).join(' · ');}

/* ============================================================
   PRODUCT CARD
   ============================================================ */
function priceBlock(p){
  const v=matchVariant(p);
  if(!v)return `<span class="quote-tag">Select options</span>`;
  if(v.price<=0)return `<span class="quote-tag">Request quote</span>`;
  const ca=v.ca?`<span class="ca">${money0(v.ca)}</span>`:'';
  const multi=p.variants.length>1&&p.options.length;
  return `<span class="price">${multi?'<span class="from">from</span>':''}${money0(v.price)}${ca}</span>`;
}
function cardHTML(p){
  const sel=getSel(p), v=matchVariant(p), img=(v&&v.img)||p.image||'';
  const opts=p.options.map(o=>`<div class="opt"><label>${esc(o.name)}</label>
     <div class="selwrap"><select data-h="${esc(p.handle)}" data-pos="${o.pos}">
       ${o.values.map(val=>`<option ${sel[o.pos]===val?'selected':''} value="${esc(val)}">${esc(val)}</option>`).join('')}
     </select></div></div>`).join('');
  const specs=(p.specs&&p.specs.length)?`
    <button class="spec-toggle" data-spec="${esc(p.handle)}"><span class="arw">▾</span> Specs &amp; details</button>
    <div class="specs">${p.specs.map(([k,val])=>`<div class="row"><b>${esc(k)}</b><span>${esc(val)}</span></div>`).join('')}
      ${p.desc?`<div class="row" style="margin-top:4px"><span style="color:var(--muted)">${esc(p.desc)}</span></div>`:''}</div>`:'';
  const skuLine=v&&v.sku?`<div class="sku-line">SKU · ${esc(v.sku)}</div>`:'';
  return `<div class="card" data-card="${esc(p.handle)}">
    <div class="chead"><div class="thumb">${img?`<img loading="lazy" src="${esc(img)}" alt="">`:''}</div>
      <div style="flex:1;min-width:0"><span class="zone-tag">${esc(ZONE_BY_ID[p._zone].label)}</span><h3>${esc(p.title)}</h3><div class="pb">${priceBlock(p)}</div></div></div>
    <div class="opts">${opts}</div>${skuLine}${specs}
    <div class="cfoot">
      <div class="stepper"><button data-step="-1" aria-label="Fewer">−</button><input type="number" min="1" value="1" data-qty><button data-step="1" aria-label="More">+</button></div>
      <button class="add" data-add="${esc(p.handle)}"><span class="pl">+</span> Add</button>
    </div></div>`;
}
function wireCards(root){
  root.querySelectorAll('.card').forEach(card=>{
    const h=card.getAttribute('data-card'), p=PRODUCTS.find(x=>x.handle===h);
    card.querySelectorAll('.opt select').forEach(sel=>sel.onchange=()=>{
      getSel(p)[sel.dataset.pos]=sel.value; saveState(); refreshCardEl(card,p);
    });
    const qtyInput=card.querySelector('[data-qty]');
    card.querySelectorAll('[data-step]').forEach(b=>b.onclick=()=>{qtyInput.value=Math.max(1,(+qtyInput.value||1)+(+b.dataset.step));});
    card.querySelector('[data-add]').onclick=()=>{
      const v=matchVariant(p);
      if(!v){toast('That combination is unavailable');return;}
      addLine(p,v,Math.max(1,+qtyInput.value||1));
      afterOrderChange(); flashCart();
      const b=card.querySelector('[data-add]');
      b.classList.add('added'); b.innerHTML='✓ Added';
      setTimeout(()=>{b.classList.remove('added');b.innerHTML='<span class="pl">+</span> Add';},1000);
    };
    const st=card.querySelector('[data-spec]');
    if(st)st.onclick=()=>{st.classList.toggle('open');card.querySelector('.specs').classList.toggle('open');};
  });
}
function refreshCardEl(card,p){
  const v=matchVariant(p), img=(v&&v.img)||p.image||'';
  card.querySelector('.thumb').innerHTML=img?`<img loading="lazy" src="${esc(img)}" alt="">`:'';
  card.querySelector('.pb').innerHTML=priceBlock(p);
  const sl=card.querySelector('.sku-line'); if(sl)sl.textContent=v&&v.sku?('SKU · '+v.sku):'';
}

/* ============================================================
   ORDER MODEL
   ============================================================ */
function addLine(p,v,qty,merge=true){
  qty=Math.max(1,qty|0);
  if(merge){const ex=state.order.find(l=>l.sku===v.sku&&l.handle===p.handle);if(ex){ex.qty+=qty;return ex;}}
  const line={id:uid(),sku:v.sku,handle:p.handle,title:p.title,zone:p._zone,
    opts:variantOptLabel(p,v),unit:v.price,ca:v.ca||0,qty,img:(v.img||p.image||'')};
  state.order.push(line); return line;
}
/* Kit pricing — buying the whole booth as one kit earns a discount. Rate is a
   starting point and expected to move; change it here and it flows everywhere
   (rail, PDF, RFQ payload). Applies only to priced lines, never to quote-only
   items, and only once the build is actually a kit rather than a single product. */
const KIT_DISCOUNT=0.05;
const KIT_DISCOUNT_MIN_ZONES=2;

function filledZoneCount(){return ZONES.filter(z=>state.order.some(l=>l.zone===z.id)).length;}

function orderTotals(){
  let sub=0,units=0,quoteItems=0;
  state.order.forEach(l=>{units+=l.qty;
    if(l.unit>0){sub+=l.unit*l.qty;}else quoteItems+=l.qty;});
  const s=state.setups||1;
  const zones=filledZoneCount();
  const gross=sub*s;
  const earned=zones>=KIT_DISCOUNT_MIN_ZONES&&gross>0;
  const discount=earned?Math.round(gross*KIT_DISCOUNT*100)/100:0;
  return {sub,units,quoteItems,lines:state.order.length,setups:s,
    zones,gross,discount,kitDiscountEarned:earned,grand:gross-discount,grandUnits:units*s};
}
function zoneSubtotal(zid){return state.order.filter(l=>l.zone===zid).reduce((a,l)=>a+(l.unit>0?l.unit*l.qty:0),0);}
function zoneCount(zid){return state.order.filter(l=>l.zone===zid).reduce((a,l)=>a+l.qty,0);}
function afterOrderChange(){saveState();renderOrder();if(currentView()==='zones')renderZones();}

/* ============================================================
   SIDEBAR
   ============================================================ */
function renderSidebar(){
  {
    const tpl=TEMPLATES.map((t,i)=>{
      let total=0;t.items.forEach(([sku,q])=>{const h=SKU_INDEX[sku.toUpperCase()];if(h)total+=h.v.price*q;});
      return `<button class="tpl" data-tpl="${i}"><div class="tt">${esc(t.name)}</div>
        <div class="td">${esc(t.desc)}</div><div class="tp"><span class="k">Prefill</span><span class="v">${money0(total)}</span></div></button>`;
    }).join('');
    $('#side').innerHTML=`<div class="side-templates"><div class="side-h">Start from a template</div>${tpl}
      <button class="tpl blank" data-tpl="blank">Start blank · clear kit</button></div>`;
    $('#side').querySelectorAll('[data-tpl]').forEach(b=>b.onclick=()=>{
      const d=b.dataset.tpl; if(d==='blank')clearKit(true); else applyTemplate(TEMPLATES[+d]);
    });
  }
}

/* ============================================================
   BUILDER VIEW
   ============================================================ */
function matchesQuery(p){
  const q=state.query.trim().toLowerCase(); if(!q)return true;
  return p.title.toLowerCase().includes(q)||p.type.toLowerCase().includes(q)||p.group.toLowerCase().includes(q)
    ||(p.tags||[]).some(t=>t.toLowerCase().includes(q))||p.variants.some(v=>(v.sku||'').toLowerCase().includes(q));
}
/* Templates are the strongest way to start, so on phones they sit in the page
   rather than behind the menu icon — and step aside once a kit exists. */
function renderStartTemplates(){
  const host=$('#tplStart'); if(!host)return;
  if(state.order.length){host.innerHTML='';return;}
  const cards=TEMPLATES.map((t,i)=>{
    let total=0;t.items.forEach(([sku,q])=>{const h=SKU_INDEX[sku.toUpperCase()];if(h)total+=h.v.price*q;});
    return `<button class="card-t" data-start="${i}">
      <div class="n">${esc(t.name)}</div><div class="d">${esc(t.desc)}</div>
      <div class="p"><small>Prefill</small>${money0(total)}</div></button>`;
  }).join('');
  host.innerHTML=`<div class="tpl-start">
    <div class="tsh">Start from a template — or build zone by zone below</div>
    <div class="row">${cards}</div></div>`;
  host.querySelectorAll('[data-start]').forEach(b=>b.onclick=()=>applyTemplate(TEMPLATES[+b.dataset.start]));
}

function renderZones(){
  const wrap=$('#zones');
  wrap.innerHTML=ZONES.map(z=>{
    const lines=state.order.filter(l=>l.zone===z.id);
    const prods=SHOPPABLE.filter(p=>p._zone===z.id && !EXCLUDE_BUILDER.has(p.handle) && matchesQuery(p));
    const sub=zoneSubtotal(z.id), cnt=zoneCount(z.id), filled=lines.length>0, isOpen=expanded.has(z.id);
    const slots=lines.map(l=>`
      <div class="slot" data-line="${l.id}">
        <div class="st" style="${l.img?`background-image:url('${esc(l.img)}')`:''}"></div>
        <div class="si"><div class="sn">${esc(l.title)}</div>${l.opts?`<div class="so">${esc(l.opts)}</div>`:''}<div class="ssku">${esc(l.sku||'—')}</div></div>
        <div style="text-align:right"><div class="sp">${l.unit>0?money0(l.unit*l.qty):'<span class="quote-tag">Quote</span>'}</div>${l.unit>0?`<div class="sunit">${money0(l.unit)} ea</div>`:''}</div>
        <div class="mini-step"><button data-mstep="-1" data-id="${l.id}">−</button><input type="number" min="1" value="${l.qty}" data-lqty="${l.id}"><button data-mstep="1" data-id="${l.id}">+</button></div>
        <button class="srm" data-rm="${l.id}" aria-label="Remove">×</button>
      </div>`).join('');
    const picker=`<div class="picker ${isOpen?'open':''}" id="picker-${z.id}">
        <div class="picker-grid">${prods.map(cardHTML).join('')||'<div class="zempty">No products match your search in this zone.</div>'}</div></div>`;
    return `<div class="zone ${filled?'filled':''}" id="zone-${z.id}">
      <div class="zhead" data-ztoggle="${z.id}">
        <div class="zidx">${z.num}</div>
        <div class="ztext"><div class="zt">${esc(z.label)} ${z.core?'<span class="tag">Essential</span>':''}</div><div class="zh">${esc(z.helper)}</div></div>
        <div class="zmeta">
          <div class="zsum">${cnt?`<b>${cnt}</b> item${cnt>1?'s':''} · <b>${money0(sub)}</b>`:'<span class="empty">Empty</span>'}</div>
          <div class="zcheck">✓</div>
        </div>
      </div>
      <div class="zbody">
        ${filled?`<div class="slots">${slots}</div>`:`<div class="zempty">Nothing added yet — browse ${prods.length} option${prods.length!==1?'s':''} below.</div>`}
        <button class="zbrowse ${isOpen?'open':''}" data-ztoggle="${z.id}" aria-expanded="${isOpen?'true':'false'}" aria-controls="picker-${z.id}">
          <span class="arw">›</span> ${isOpen?'Hide options':`${filled?'Add another':'Browse'} (${prods.length})`}
        </button>
        ${picker}
      </div></div>`;
  }).join('');
  wrap.querySelectorAll('[data-ztoggle]').forEach(el=>el.onclick=e=>{
    if(el.classList.contains('zhead')){
      /* On phones the button is the only way in — a whole-header hit target
         competing with it is what makes the screen feel unpredictable. */
      if(isPhone()||e.target.closest('.zbrowse'))return;
    }
    toggleZone(el.dataset.ztoggle);
  });
  wrap.querySelectorAll('.picker.open').forEach(pk=>wireCards(pk));
  wireOrderControls(wrap);
  const sa=$('#seeAll');
  if(sa){
    sa.innerHTML=`<div class="seeall"><div class="t">Looking for something else?</div>
      <div class="s">Every product in one list — each one shows the zone it joins.</div>
      <button id="btnSeeAll">See all ${SHOPPABLE.length} products</button></div>`;
    $('#btnSeeAll').onclick=()=>showAllProducts(true);
  }
  renderStartTemplates();
  renderComp();
  renderSidebar(); addPanelCloseControls();
}
function toggleZone(z){ expanded.has(z)?expanded.delete(z):expanded.add(z); renderZones(); }
function openZone(z){ if(!expanded.has(z)){expanded.add(z);renderZones();} }

function renderComp(){
  const total=ZONES.length, done=ZONES.filter(z=>state.order.some(l=>l.zone===z.id)).length;
  const emptyCore=ZONES.filter(z=>z.core&&!state.order.some(l=>l.zone===z.id));
  const ticks=ZONES.map(z=>{const f=state.order.some(l=>l.zone===z.id);return `<i class="${f?(done===total?'all':'on'):''}"></i>`;}).join('');
  /* This used to say "All essentials covered" the moment the four core zones had
     anything in them — congratulating people on a booth that was still missing
     three zones. It now only claims what is actually true. */
  const emptyRest=ZONES.filter(z=>!z.core&&!state.order.some(l=>l.zone===z.id));
  const nudge=!done
    ? `Nothing added yet · start with <b>${ZONES.filter(z=>z.core)[0].label}</b>`
    : emptyCore.length
      ? `Still open · <b>${emptyCore.map(z=>z.label.split(' ')[0]).join(', ')}</b>`
      : emptyRest.length
        ? `Essentials in place · worth a look: <b>${emptyRest.map(z=>z.label.split(' ')[0].replace(/&/,'')).join(', ')}</b>`
        : `Every zone covered ✓`;
  $('#comp').innerHTML=`<div class="comp-top"><span class="micro">Kit completeness</span><span class="v">${done}/${total}</span></div>
    <div class="ticks">${ticks}</div><div class="nudge">${nudge}</div>`;
}

/* ============================================================
   CATALOG VIEW
   ============================================================ */
function filtered(searching){
  let list=SHOPPABLE.slice();
  if(!searching&&state.group!=='All')list=list.filter(p=>p.group===state.group);
  list=list.filter(matchesQuery);
  const s=state.sort;
  if(s==='price-asc')list.sort((a,b)=>a.pmin-b.pmin);
  else if(s==='price-desc')list.sort((a,b)=>b.pmax-a.pmax);
  else if(s==='name')list.sort((a,b)=>a.title.localeCompare(b.title));
  return list;
}
function renderProducts(view){
  const searching=view==='results';
  const list=filtered(searching);
  $('#resCount').textContent=list.length;

  $('#resBar').innerHTML=searching
    ? `<div class="rq">Results for <em>“${esc(state.query.trim())}”</em></div>
       <div class="rn">${list.length} product${list.length===1?'':'s'} · every zone searched</div>
       <button class="rx" id="resClear">Clear search</button>`
    : `<div class="rq">All products</div>
       <div class="rn">${SHOPPABLE.length} products · add any of them to your kit</div>
       <button class="rx" id="resBack">← Back to my kit</button>`;

  /* Categories are a filter here, never a way to navigate the app. */
  $('#chips').innerHTML=searching?'':(()=>{
    const counts={All:SHOPPABLE.length};
    GROUPS.forEach(g=>counts[g]=SHOPPABLE.filter(p=>p.group===g).length);
    return ['All',...GROUPS].map(c=>`<button data-cat="${esc(c)}" class="${state.group===c?'on':''}">${esc(c)}<span class="n">${counts[c]}</span></button>`).join('');
  })();

  const g=$('#grid'); g.className='grid'+(state.density==='compact'?' compact':'');
  g.innerHTML=list.length
    ? list.map(cardHTML).join('')
    : `<div style="grid-column:1/-1;text-align:center;color:var(--faint);padding:60px 20px">
         <div style="font-family:var(--display);font-size:17px;color:var(--muted);margin-bottom:6px">No products match “${esc(state.query.trim())}”</div>
         <div style="font-size:12.5px">Try a shorter word, or clear the search to see all ${SHOPPABLE.length}.</div></div>`;
  if(list.length)wireCards(g);

  const dirty=state.group!=='All'||state.sort!=='featured';
  $('#clearFilters').classList.toggle('hidden',searching||!dirty);
  $('#toolbar').classList.toggle('hidden',searching&&!list.length);
  const cl=$('#resClear'); if(cl)cl.onclick=()=>clearSearch();
  const bk=$('#resBack'); if(bk)bk.onclick=()=>showAllProducts(false);
  $('#chips').querySelectorAll('[data-cat]').forEach(b=>b.onclick=()=>{state.group=b.dataset.cat;saveState();renderProducts(currentView());});
}

function clearSearch(){
  state.query=''; const i=$('#search'); if(i)i.value='';
  if(isPhone())toggleSearch(false); else renderView();
}

/* ============================================================
   RAIL
   ============================================================ */
function renderOrder(){
  const box=$('#lines');
  if(!state.order.length){
    box.innerHTML=`<div class="empty"><div class="mk">＋</div><p>Your kit is empty</p>
      <div class="sub">Prefill a template, fill a zone,<br>or paste a SKU above.</div></div>`;
  } else {
    let html='';
    ZONES.forEach(z=>{
      const lines=state.order.filter(l=>l.zone===z.id); if(!lines.length)return;
      html+=`<div class="zgroup"><div class="zglabel"><span class="zgn">${z.num}</span><span class="zgt">${esc(z.label)}</span><span class="zgs">${money0(zoneSubtotal(z.id))}</span></div>`;
      html+=lines.map(l=>`<div class="line" data-line="${l.id}">
        <button class="rm" data-rm="${l.id}" aria-label="Remove">×</button>
        <div class="lt" style="${l.img?`background-image:url('${esc(l.img)}')`:''}"></div>
        <div class="li"><div class="ln">${esc(l.title)}</div>${l.opts?`<div class="lo">${esc(l.opts)}</div>`:''}<div class="lsku">${esc(l.sku||'—')}</div>
          <select class="zmove" data-zmove="${l.id}" aria-label="Move to another zone">
            ${ZONES.map(z=>`<option value="${z.id}" ${z.id===l.zone?'selected':''}>${esc(z.label)}</option>`).join('')}
          </select></div>
        <div class="lr"><div class="lprice">${l.unit>0?money0(l.unit*l.qty):'<span class="quote-tag">Quote</span>'}</div>
          <div class="mini-step"><button data-mstep="-1" data-id="${l.id}">−</button><input type="number" min="1" value="${l.qty}" data-lqty="${l.id}"><button data-mstep="1" data-id="${l.id}">+</button></div>
          ${l.unit>0?`<div class="lunit">${money0(l.unit)} ea</div>`:''}</div></div>`).join('');
      html+=`</div>`;
    });
    box.innerHTML=html; wireOrderControls(box);
  }
  renderFoot();
  const t=orderTotals();
  $('#cartCnt').textContent=t.grandUnits;
  $('#cartTot').textContent=t.grand>0?money0(t.grand):'';
}
function moveLine(id,zoneId){
  const l=state.order.find(x=>x.id===id); if(!l||l.zone===zoneId)return;
  l.zone=zoneId; afterOrderChange();
  toast('Moved to '+ZONE_BY_ID[zoneId].label);
}
function wireOrderControls(root){
  root.querySelectorAll('[data-zmove]').forEach(sel=>sel.onchange=()=>moveLine(sel.dataset.zmove,sel.value));
  root.querySelectorAll('[data-rm]').forEach(b=>b.onclick=()=>{state.order=state.order.filter(l=>l.id!==b.dataset.rm);afterOrderChange();});
  root.querySelectorAll('[data-mstep]').forEach(b=>b.onclick=()=>{const l=state.order.find(x=>x.id===b.dataset.id);if(l){l.qty=Math.max(1,l.qty+(+b.dataset.mstep));afterOrderChange();}});
  root.querySelectorAll('[data-lqty]').forEach(inp=>inp.onchange=()=>{const l=state.order.find(x=>x.id===inp.dataset.lqty);if(l){l.qty=Math.max(1,+inp.value||1);afterOrderChange();}});
}
function renderFoot(){
  const t=orderTotals(), po=state.po, multi=t.setups>1;
  const setupsRow=`<div class="setups-row"><div class="sl">Identical setups<small>Scales the whole kit</small></div>
    <div class="mini-step"><button type="button" data-fsetup="-1">−</button><input type="number" min="1" max="99" value="${t.setups}" id="setupsFoot" aria-label="Number of identical setups"><button type="button" data-fsetup="1">+</button></div></div>`;
  const quoteNote=t.quoteItems?`<div class="quote-note"><span class="dot"></span><span>${t.quoteItems*t.setups} custom item(s) priced on quote — our team confirms pricing.</span></div>`:'';
  const perKitRow=multi?`<div class="r"><span>Per setup</span><b>${money(t.sub)}</b></div><div class="r"><span>× ${t.setups} setups</span><b>${t.grandUnits} units</b></div>`:'';
  const kitRow=t.kitDiscountEarned
    ?`<div class="r"><span>Kit discount · ${Math.round(KIT_DISCOUNT*100)}%</span><b style="color:var(--accent-deep)">−${money(t.discount)}</b></div>`
    :(t.gross>0?`<div class="kit-nudge">Fill <b>${KIT_DISCOUNT_MIN_ZONES-t.zones}</b> more zone${KIT_DISCOUNT_MIN_ZONES-t.zones>1?'s':''} to earn the ${Math.round(KIT_DISCOUNT*100)}% kit discount</div>`:'');
  const sub=state.submission, changed=sub&&sub.fingerprint!==kitFingerprint();
  const grossRow=t.kitDiscountEarned?`<div class="r"><span>Subtotal</span><b>${money(t.gross)}</b></div>`:'';
  const totalLabel=t.quoteItems&&t.grand>0?'Priced items estimate':'Estimated total';
  const totalValue=t.quoteItems&&!t.grand?'Custom quote':money(t.grand);
  const totalsBlock=`<div class="totals"><div class="r"><span>Line items</span><b>${t.lines}</b></div>${perKitRow}${grossRow}${kitRow}
      <div class="r grand"><span>${totalLabel}</span><b>${totalValue}</b></div></div>`;

  /* --- Submitted: the drawer keeps the build and shows what happened to it --- */
  if(sub){
    const staleNote=changed?`<div class="stale">You have <b>changed this kit</b> since sending it.
      Send it again and our team will treat the newer request as the current one.</div>`:'';
    $('#foot').innerHTML=`
      <div class="foot-scroll">
      <div class="sent">
        <div class="top"><span class="tick">✓</span><span class="th">Quote request accepted</span></div>
        <p>Your request returned from the contact form. A rep will follow up at <b>${esc(sub.emailMasked||sub.email||'the address you gave')}</b>, usually within one business day.</p>
        <div class="meta">${esc(sub.sentLabel)}${sub.id?` · ${esc(sub.id)}`:''}</div>
      </div>
      ${staleNote}
      ${totalsBlock}
      ${quoteNote}
      ${changed?`<p class="mvp-ai-artwork-notice" data-mvp-ai-artwork="rfq" style="display:block;box-sizing:border-box;max-width:100%;margin:12px 0 18px;padding:12px 14px;border:1px solid #ded8cc;border-radius:4px;background:#fcfaf6;color:#505050;font-family:inherit;font-size:14px;font-weight:400;line-height:1.55;letter-spacing:normal;text-transform:none;white-space:normal;overflow-wrap:break-word;grid-column:1/-1;scroll-margin-top:140px">Please provide high resolution files for production. AI-generated or incompatible files may require adjustments or recreation, which may incur additional design fees.</p>`:''}
      </div>
      <div class="actions">
        <button class="primary" id="btnQuote" type="button">${changed?'Send updated quote <span class="arw">→</span>':'Print / Save as PDF'}</button>
      </div>
      <button type="button" class="link" id="btnNewKit">Start a new kit</button>`;
    if(changed)bindGenerateQuote();
    else $('#btnQuote').onclick=()=>printQuote(sub.payload||{submission_id:sub.id});
    $('#btnNewKit').onclick=startNewKit;
    return;
  }

  /* --- Building --- */
  $('#foot').innerHTML=`<div class="foot-scroll">${setupsRow}
    <div class="fields-h">Your details <span class="req">· so we can send your quote</span></div>
    <div class="po-fields">
      <input class="full" id="poReq" name="contact[name]" form="${RFQ.nativeFormId}" required aria-label="Your name (required)" placeholder="Your name *" autocomplete="name" value="${esc(po.reqby)}">
      <input class="full" id="poEmail" name="contact[email]" form="${RFQ.nativeFormId}" required type="email" aria-label="Email address (required)" placeholder="Email *" autocomplete="email" value="${esc(po.email)}">
      <input id="poCompany" name="contact[company]" form="${RFQ.nativeFormId}" required aria-label="Company (required)" placeholder="Company *" autocomplete="organization" value="${esc(po.company)}" maxlength="35" data-mvp-rfq-organization title="Maximum 35 characters">
      <input id="poPhone" name="contact[phone]" form="${RFQ.nativeFormId}" required type="tel" aria-label="Phone number (required)" placeholder="Phone *" autocomplete="tel" value="${esc(po.phone)}">
      <label class="fld"><span>Event date (optional)</span>
        <input id="poDate" type="date" min="${todayISO()}" value="${esc(po.eventDate)}"></label>
      <input class="full" id="poShip" aria-label="Ship-to city (optional)" placeholder="Ship-to city (optional)" autocomplete="address-level2" value="${esc(po.ship)}">
      <div class="field-err" id="poErr"></div>
    </div>
    ${totalsBlock}
    ${quoteNote}
    <p class="mvp-ai-artwork-notice" data-mvp-ai-artwork="rfq" style="display:block;box-sizing:border-box;max-width:100%;margin:12px 0 18px;padding:12px 14px;border:1px solid #ded8cc;border-radius:4px;background:#fcfaf6;color:#505050;font-family:inherit;font-size:14px;font-weight:400;line-height:1.55;letter-spacing:normal;text-transform:none;white-space:normal;overflow-wrap:break-word;grid-column:1/-1;scroll-margin-top:140px">Please provide high resolution files for production. AI-generated or incompatible files may require adjustments or recreation, which may incur additional design fees.</p>
    </div>
    <div class="actions">
      <button class="primary" id="btnQuote" type="submit" form="${RFQ.nativeFormId}">Generate Quote <span class="arw">→</span></button>
    </div>`;
  const bind=(id,key)=>{const el=$(id);if(el){const sync=()=>{state.po[key]=el.value;el.classList.remove('err');saveState();};el.oninput=sync;el.onchange=sync;}};
  bind('#poReq','reqby');bind('#poShip','ship');bind('#poDate','eventDate');
  bind('#poEmail','email');bind('#poCompany','company');bind('#poPhone','phone');
  $('#foot').querySelectorAll('[data-fsetup]').forEach(b=>b.onclick=()=>setSetups(state.setups+(+b.dataset.fsetup)));
  $('#setupsFoot').onchange=e=>setSetups(+e.target.value||1);
  bindGenerateQuote();
}

function bindGenerateQuote(){
  const btn=$('#btnQuote'); if(!btn)return;
  const form=document.getElementById(RFQ.nativeFormId);
  if(form){
    btn.type='submit'; btn.setAttribute('form',RFQ.nativeFormId); btn.onclick=null;
    if(!form.dataset.ekbBound){form.addEventListener('submit',generateQuote);form.dataset.ekbBound='true';}
  }else{
    btn.type='button'; btn.removeAttribute('form'); btn.onclick=generateQuote;
  }
}

/* Identity of the kit as sent — lets the drawer notice edits made afterwards. */
function kitFingerprint(){
  return (state.setups||1)+'|'+state.order.map(l=>l.sku+'x'+l.qty).sort().join(',');
}
function startNewKit(){
  if(state.order.length&&!confirm('Start a new kit? Your current build is cleared — the quote you already sent is unaffected.'))return;
  pendingSubmissionId=null;clearQuote();
  state.order=[]; state.submission=null; expanded.clear();
  afterOrderChange(); toast('Ready for a new kit');
}
const MAX_SETUPS=99;
function setSetups(n){
  const want=n|0;
  if(want>MAX_SETUPS)toast('Need more than '+MAX_SETUPS+' setups? Our team will quote that directly.');
  state.setups=Math.min(MAX_SETUPS,Math.max(1,want));const h=$('#setupsHero');if(h)h.value=state.setups;saveState();renderOrder();}

/* ============================================================
   TEMPLATES + KIT ACTIONS
   ============================================================ */
function applyTemplate(t){
  state.order=[]; let n=0;
  t.items.forEach(([sku,q])=>{const hit=SKU_INDEX[sku.toUpperCase()];if(hit){addLine(hit.p,hit.v,q,false);n+=q;}});
  expanded.clear(); afterOrderChange(); flashCart();
  toast(`Loaded ${t.name} · ${n} items`);
}
function clearKit(ask){
  if(ask&&state.order.length&&!confirm('Clear all items from your kit?'))return;
  state.order=[]; afterOrderChange();
}

/* ============================================================
   EXPORTS
   ============================================================ */
function exportRows(){
  const s=state.setups||1;
  return state.order.map(l=>({sku:l.sku||'',product:l.title,zone:ZONE_BY_ID[l.zone].label,options:l.opts||'',
    qty:l.qty*s,unit:l.unit,line:l.unit*l.qty*s}));
}
/* ============================================================
   RFQ — contract v1 (see rfq-intake/contracts/rfq-contract-v1.json)
   ============================================================ */
function todayISO(){const d=new Date();return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');}
function prettyDate(iso){if(!iso)return null;const [y,m,d]=iso.split('-').map(Number);
  return new Date(y,m-1,d).toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'});}
function isValidEmail(v){return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v||'').trim());}

/* Native date pickers and browser autofill do not consistently emit the same
   event. Read the rendered controls before validation so what the customer sees
   is always what the RFQ sends. */
function syncRfqFields(){
  [['#poReq','reqby'],['#poEmail','email'],['#poCompany','company'],['#poPhone','phone'],['#poDate','eventDate'],['#poShip','ship']]
    .forEach(([sel,key])=>{const el=$(sel);if(el)state.po[key]=el.value;});
  saveState();
}

function validateRfq(){
  syncRfqFields();
  const po=state.po, bad=[];
  if(!(po.reqby||'').trim()) bad.push(['#poReq','your name']);
  if(!isValidEmail(po.email)) bad.push(['#poEmail','a valid email address']);
  if(!(po.company||'').trim()) bad.push(['#poCompany','your company name']);
  else if(po.company.length>35) bad.push(['#poCompany','a company name of 35 characters or fewer']);
  if((po.phone||'').replace(/\D/g,'').length<7) bad.push(['#poPhone','a phone number']);
  $$('#foot .po-fields input').forEach(i=>i.classList.remove('err'));
  const err=$('#poErr');
  if(bad.length){
    bad.forEach(([sel])=>{const el=$(sel);if(el)el.classList.add('err');});
    const list=bad.map(b=>b[1]), phrase=list.length>1?list.slice(0,-1).join(', ')+' and '+list[list.length-1]:list[0];
    if(err){err.textContent='Please enter '+phrase+'.';err.classList.add('show');}
    const first=$(bad[0][0]); if(first){openRail();first.focus();}
    return false;
  }
  if(err){err.textContent='';err.classList.remove('show');}
  return true;
}

function submissionId(){
  const d=new Date(), p=n=>String(n).padStart(2,'0');
  const stamp=d.getFullYear()+p(d.getMonth()+1)+p(d.getDate())+p(d.getHours())+p(d.getMinutes())+p(d.getSeconds());
  let rand=''; for(let i=0;i<12;i++) rand+='0123456789ABCDEF'[Math.floor(Math.random()*16)];
  return 'RFQ-KIT-'+stamp+'-'+rand;
}

function rfqLineItems(){
  return exportRows().map((r,i)=>{
    const p=PRODUCTS.find(x=>x.title===r.product);
    const specs={};
    if(r.sku)specs.SKU=r.sku;
    (r.options||'').split(' · ').filter(Boolean).forEach((v,n)=>{
      const name=(p&&p.options[n]&&p.options[n].name)||('Option '+(n+1)); specs[name]=v;
    });
    return {
      product:r.product,
      product_handle:p?p.handle:null,
      product_url:p?('https://mvpvisuals.com/products/'+p.handle):null,
      product_group:p?p.group:null,
      product_kind:r.zone||null,
      data_source:'event_kit_builder_catalog',
      quantity:r.qty,
      unit_price:r.unit>0?r.unit:null,
      line_estimate:r.unit>0?r.line:'Custom quote',
      custom_quote_required:!(r.unit>0),
      specifications:specs,
      custom_width_ft:null, custom_height_ft:null, custom_size_label:null
    };
  });
}

function rfqEmailBody(payload){
  const t=orderTotals(), po=state.po, L=[];
  L.push('NEW RFQ');
  L.push('Submission ID: '+payload.submission_id);
  L.push('Product: '+RFQ.product_type);
  L.push('Source: Event Kit Builder');
  L.push('');
  L.push('CONTACT');
  L.push('Name: '+po.reqby);
  L.push('Company / Organization: '+po.company);
  L.push('Email: '+po.email);
  L.push('Phone: '+po.phone);
  L.push('');
  L.push('TIMING AND DESTINATION');
  L.push('Event date: '+(prettyDate(po.eventDate)||'not given'));
  if((po.ship||'').trim()) L.push('Destination: '+po.ship);
  L.push('');
  L.push('CONFIGURATION');
  L.push('Event display kit x '+t.setups+' identical setup(s)');
  payload.line_items.forEach(li=>{
    const opts=Object.keys(li.specifications).map(k=>k+': '+li.specifications[k]).join(', ');
    L.push('  '+li.quantity+' x '+li.product+(opts?' ('+opts+')':'')+' — '+
      (li.custom_quote_required?'Custom quote':money(li.line_estimate)));
  });
  L.push('');
  L.push('ESTIMATE');
  L.push('Total units: '+t.grandUnits);
  if(t.kitDiscountEarned){
    L.push('Subtotal: '+money(t.gross));
    L.push('Kit discount ('+Math.round(KIT_DISCOUNT*100)+'%): -'+money(t.discount));
  }
  if(t.quoteItems&&!t.grand)L.push('Estimated total: Custom quote');
  else L.push((t.quoteItems?'Priced items estimate':'Estimated total')+': '+money(t.grand));
  if(t.quoteItems) L.push('Custom-quote items: '+(t.quoteItems*t.setups)+' (priced by an MVP Visuals rep)');
  L.push('');
  L.push('CONTEXT');
  L.push('Landing page: '+location.href);
  L.push('Submitted at: '+payload.submitted_at);
  return L.join('\n');
}

function buildRfqPayload(existingSubmissionId){
  const t=orderTotals(), po=state.po, q=new URLSearchParams(location.search);
  const payload={
    schema_version:RFQ.schema_version,
    submission_id:existingSubmissionId||submissionId(),
    submitted_at:new Date().toISOString(),
    source_widget:RFQ.source_widget,
    product_type:RFQ.product_type,
    product_subtype:t.setups>1?(t.setups+' identical setups'):'Single setup',
    contact:{
      first_name:null, last_name:null,
      full_name:(po.reqby||'').trim(),
      organization:(po.company||'').trim(),
      email:(po.email||'').trim(),
      phone:(po.phone||'').trim()
    },
    request:{
      budget:{value:null,label:null},
      timeline:null,
      in_hands_date:(po.eventDate||'').trim()||null,
      destination:(po.ship||'').trim()||null,
      quantity:t.grandUnits,
      estimate_label:t.quoteItems?(t.grand>0?money(t.grand)+' priced items + custom quote':'Custom quote'):money(t.grand),
      estimated_total:t.grand>0?t.grand:null,
      custom_quote_required:t.quoteItems>0,
      configuration_summary:'Event display kit x '+t.setups+' setup(s), '+t.lines+' line item(s)',
      notes:null
    },
    artwork:{status:'Not collected in kit builder',files_selected:[],links:[]},
    attribution:{
      gclid:q.get('gclid')||null,
      utm_source:q.get('utm_source')||null, utm_medium:q.get('utm_medium')||null,
      utm_campaign:q.get('utm_campaign')||null, utm_term:q.get('utm_term')||null,
      utm_content:q.get('utm_content')||null
    },
    context:{landing_page:location.href, referrer:document.referrer||null, user_agent:navigator.userAgent},
    details:{setups:t.setups, per_setup_subtotal:t.sub,
      subtotal_before_kit_discount:t.gross, kit_discount_rate:t.kitDiscountEarned?KIT_DISCOUNT:0,
      kit_discount_amount:t.discount, zones_filled:ZONES.filter(z=>state.order.some(l=>l.zone===z.id)).map(z=>z.label)},
    line_items:rfqLineItems()
  };
  payload.email_body=(EKB_CONFIG.testMode?'[TEST SUBMISSION — internal build]\n\n':'')+rfqEmailBody(payload);
  return payload;
}

/* Lane 1: structured Google Sheet intake. It is deliberately fail-open because
   Shopify's native contact form below remains the authoritative sales email. */
function sendRfqToSheet(payload){
  if(window.mvpRfqSubmission)return window.mvpRfqSubmission.dispatchSheet(RFQ.sheetEndpoint,payload,'company_url','');
  if(!RFQ.sheetEndpoint)return Promise.resolve({state:'unconfigured'});
  const body=new URLSearchParams({rfq_payload_json:JSON.stringify(payload),company_url:''});
  return fetch(RFQ.sheetEndpoint,{method:'POST',mode:'no-cors',keepalive:true,body}).then(()=>({state:'unconfirmed'}),error=>{console.warn('RFQ receipt unconfirmed',error);return {state:'unconfirmed'};});
}

/* Lane 2: populate Shopify's real contact form. form.elements includes the visible
   contact controls associated with the form through their `form` attributes. */
function prepareRfqShopifyForm(form,payload){
  if(!form)return false;
  const required=['contact[name]','contact[email]','contact[phone]','contact[company]','contact[source_widget]','contact[submission_id]','contact[body]'];
  if(required.some(name=>!form.elements.namedItem(name)))return false;
  const set=(name,value)=>{form.elements.namedItem(name).value=value==null?'':value;};
  set('contact[name]',payload.contact.full_name);set('contact[email]',payload.contact.email);
  set('contact[phone]',payload.contact.phone);set('contact[company]',payload.contact.organization);
  set('contact[source_widget]',payload.source_widget);set('contact[submission_id]',payload.submission_id);set('contact[body]',payload.email_body);
  return true;
}

/* The receipt survives Shopify's optional CAPTCHA and full-page redirect. It is
   session-scoped and is deleted immediately after the success state is restored. */
const QUOTE_KEY='mvp_kit_quote_v2';
function stashQuote(payload){try{sessionStorage.setItem(QUOTE_KEY,JSON.stringify(payload));}catch(error){}}
function takeQuote(){
  try{
    const raw=sessionStorage.getItem(QUOTE_KEY),payload=raw?JSON.parse(raw):null;
    const at=payload?Date.parse(payload.submitted_at):NaN;
    if(payload&&(!Number.isFinite(at)||Date.now()-at>3600000||Date.now()<at)){clearQuote();return null;}
    return payload;
  }catch(error){clearQuote();return null;}
}
function clearQuote(){try{sessionStorage.removeItem(QUOTE_KEY);}catch(error){}}

let submitting=false, pendingSubmissionId=null, submitRecoveryTimer=null;
function releaseSubmitWait(){
  submitting=false;
  const b=$('#btnQuote');
  if(b){b.style.opacity='';b.removeAttribute('aria-busy');b.removeAttribute('aria-disabled');}
}
function nativeFormInFlight(){const form=document.getElementById(RFQ.nativeFormId);return Boolean(form&&form.getAttribute('aria-busy')==='true');}
function generateQuote(event){
  const stop=()=>{if(event&&event.preventDefault)event.preventDefault();};
  if(submitting){if(nativeFormInFlight())return;stop();return;}
  if(!state.order.length){stop();toast('Add items to your kit first');return;}
  if(!validateRfq()){stop();return;}
  const nativeForm=document.getElementById(RFQ.nativeFormId);
  const payload=buildRfqPayload(pendingSubmissionId);
  if(!nativeForm||!prepareRfqShopifyForm(nativeForm,payload)){
    stop();toast("We couldn't prepare the email. Please try again.");return;
  }
  const attempt=window.mvpRfqSubmission&&window.mvpRfqSubmission.beginNative(nativeForm,{widget:'event-kit',submissionId:payload.submission_id,button:$('#btnQuote'),onRelease:releaseSubmitWait});
  if(attempt&&attempt.repeat)return;
  submitting=true;
  const btn=$('#btnQuote'); if(btn){btn.style.opacity='.65';btn.setAttribute('aria-busy','true');btn.setAttribute('aria-disabled','true');}
  pendingSubmissionId=payload.submission_id;
  const err=$('#poErr');if(err){err.textContent='';err.classList.remove('show');}
  stashQuote(payload);
  sendRfqToSheet(payload);
  clearTimeout(submitRecoveryTimer);
  submitRecoveryTimer=setTimeout(releaseSubmitWait,30000);

  /* When the native form exists, do not prevent the submit event. Shopify owns
     hCaptcha, the /contact POST, store-email delivery and return navigation. */
}

/* One record, kept on the device, so a returning visitor opens the drawer and
   sees the build they sent and what happened to it. */
function markSubmitted(payload){
  pendingSubmissionId=null;
  clearTimeout(submitRecoveryTimer);
  submitting=false;
  const at=payload.submitted_at||new Date().toISOString(), contact=payload.contact||{};
  state.submission={
    id:payload.submission_id||'',
    at:at,
    sentLabel:new Date(at).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}),
    email:contact.email||'',
    emailMasked:maskEmail(contact.email||''),
    fingerprint:payload.fingerprint||kitFingerprint(),
    payload:payload
  };
  clearQuote();
  saveState(); renderOrder(); openRail();
  toast('Your quote request was accepted.');
}

function resumeAfterContactPost(){
  const status=$('#ekb-contact-status'),payload=takeQuote();
  const receipt=window.mvpRfqSubmission&&window.mvpRfqSubmission.returned({widget:'event-kit',posted:Boolean(status&&status.dataset.posted==='true'),errors:Boolean(status&&status.dataset.errors==='true'),submissionId:payload&&payload.submission_id,consume:false});
  if(!receipt){
    pendingSubmissionId=payload&&payload.submission_id?payload.submission_id:null;
    if(new URLSearchParams(location.search).get('contact_posted')==='true')toast('We could not confirm this return. Please contact us to check your request.');
    return;
  }
  // The native return corroborates this browser attempt. Do not issue a
  // second Sheet POST without a verified backend deduplication contract.
  if(payload)markSubmitted(payload);else toast('Your quote request was accepted.');
  if(history.replaceState){const cleanUrl=new URL(location.href);cleanUrl.searchParams.delete('contact_posted');cleanUrl.searchParams.delete('mvp_rfq_receipt');history.replaceState(null,'',cleanUrl.pathname+cleanUrl.search+cleanUrl.hash);}
}

function printQuote(payload){
  if(!state.order.length){toast('Kit is empty');return;}
  const t=orderTotals(),po=state.po,rows=exportRows();
  const sid=(payload&&payload.submission_id)||'';
  const today=new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'});
  const bodyRows=rows.map((r,i)=>`<tr><td style="color:#888">${i+1}</td>
    <td style="font-family:monospace;font-size:11px">${esc(r.sku||'—')}</td>
    <td><b>${esc(r.product)}</b>${r.options?`<br><span style="color:#666;font-size:11px">${esc(r.options)}</span>`:''}<br><span style="color:#b98a1e;font-size:10px">${esc(r.zone)}</span></td>
    <td style="text-align:center">${r.qty}</td>
    <td style="text-align:right">${r.unit>0?money(r.unit):'Quote'}</td>
    <td style="text-align:right;font-weight:700">${r.unit>0?money(r.line):'Quote'}</td></tr>`).join('');
  $('#quotesheet').innerHTML=`
    <div style="display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #f1b241;padding-bottom:10px;margin-bottom:13px">
      <div><div style="font-size:24px;font-weight:800;letter-spacing:-.5px">MVP Visuals</div><div style="color:#666;font-size:12px">Custom Event &amp; Trade Show Branding</div></div>
      <div style="text-align:right"><div style="font-size:20px;font-weight:800;color:#c1861d">QUOTE</div><div style="font-size:12px;color:#666">${today}</div>${sid?`<div style="font-size:10px;color:#999;font-family:monospace">${esc(sid)}</div>`:''}</div></div>
    <div style="display:flex;gap:34px;font-size:12px;margin-bottom:11px;flex-wrap:wrap">
      <div><div style="color:#999;text-transform:uppercase;font-size:10px;letter-spacing:.05em">Configuration</div><b>Event display kit × ${t.setups} setup(s)</b></div>
      ${po.company?`<div><div style="color:#999;text-transform:uppercase;font-size:10px;letter-spacing:.05em">Company</div><b>${esc(po.company)}</b></div>`:''}
      ${po.email?`<div><div style="color:#999;text-transform:uppercase;font-size:10px;letter-spacing:.05em">Email</div><b>${esc(po.email)}</b></div>`:''}
      ${po.phone?`<div><div style="color:#999;text-transform:uppercase;font-size:10px;letter-spacing:.05em">Phone</div><b>${esc(po.phone)}</b></div>`:''}
      ${po.reqby?`<div><div style="color:#999;text-transform:uppercase;font-size:10px;letter-spacing:.05em">Contact</div><b>${esc(po.reqby)}</b></div>`:''}
      ${po.eventDate?`<div><div style="color:#999;text-transform:uppercase;font-size:10px;letter-spacing:.05em">Event date</div><b>${esc(prettyDate(po.eventDate))}</b></div>`:''}
      ${po.ship?`<div><div style="color:#999;text-transform:uppercase;font-size:10px;letter-spacing:.05em">Ship to</div><b>${esc(po.ship)}</b></div>`:''}</div>
    <table style="width:100%;border-collapse:collapse;font-size:12.5px">
      <thead><tr style="background:#f3efed;text-align:left"><th style="padding:8px 6px;width:22px">#</th><th style="padding:8px 6px">SKU</th><th style="padding:8px 6px">Description</th><th style="padding:8px 6px;text-align:center">Qty</th><th style="padding:8px 6px;text-align:right">Unit</th><th style="padding:8px 6px;text-align:right">Total</th></tr></thead>
      <tbody>${bodyRows}</tbody></table>
    <div class="qs-tail"><div style="display:flex;justify-content:flex-end;margin-top:11px"><table style="font-size:13px">
      <tr><td style="padding:3px 20px 3px 0;color:#666">Total units</td><td style="text-align:right;font-weight:700">${t.grandUnits}</td></tr>
      ${t.kitDiscountEarned?`<tr><td style="padding:3px 20px 3px 0;color:#666">Subtotal</td><td style="text-align:right;font-weight:700">${money(t.gross)}</td></tr>
      <tr><td style="padding:3px 20px 3px 0;color:#8a5f14">Kit discount · ${Math.round(KIT_DISCOUNT*100)}%</td><td style="text-align:right;color:#8a5f14;font-weight:700">−${money(t.discount)}</td></tr>`:''}
      <tr style="border-top:2px solid #1d1d1d"><td style="padding:8px 20px 3px 0;font-size:16px;font-weight:800">${t.quoteItems&&t.grand>0?'Priced items estimate':'Estimated total'}</td><td style="text-align:right;font-size:18px;font-weight:800">${t.quoteItems&&!t.grand?'Custom quote':money(t.grand)}</td></tr></table></div>
    ${t.quoteItems?`<div style="margin-top:14px;font-size:11px;color:#c1861d;background:#fbeecf;padding:9px 12px;border-radius:4px">* ${t.quoteItems*t.setups} custom item(s) are priced on quote. Final pricing confirmed by an MVP Visuals rep.</div>`:''}
    <div style="margin-top:13px;font-size:10.5px;color:#999;border-top:1px solid #eee;padding-top:8px">Prices exclude applicable taxes, shipping, and setup unless noted. Quote valid 30 days. Generated via MVP Visuals Event Display Builder.${DATA.built?` · Catalog ${esc(DATA.built)}`:''}</div></div>`;
  window.print();
}

/* ============================================================
   SKU quick-add
   ============================================================ */
function quickAddSku(raw){
  const skus=raw.split(/[\s,;]+/).map(s=>s.trim().toUpperCase()).filter(Boolean);
  let added=0,miss=[],blocked=[];
  skus.forEach(sku=>{const hit=SKU_INDEX[sku];
    if(hit&&NOT_SHOPPABLE.has(hit.p.handle)){blocked.push(hit.p.title);return;}
    if(hit){addLine(hit.p,hit.v,1,true);added++;}else miss.push(sku);});
  if(added){afterOrderChange();flashCart();}
  if(blocked.length)toast(`${blocked[0]} is quoted by our team, not added as a line`);
  else if(added&&!miss.length)toast(`Added ${added} item(s) by SKU`);
  else if(added)toast(`Added ${added}; not found: ${miss.slice(0,3).join(', ')}`);
  else toast(`SKU not found: ${miss.slice(0,3).join(', ')}`);
}

/* ============================================================
   MODE + UI plumbing
   ============================================================ */
/* There is no Build-vs-Browse mode any more. One page, and what it shows is
   derived from what the user did: a search always wins, "See all" is a detour,
   and the kit page is home. */
function currentView(){
  if(state.query.trim())return 'results';
  return state.showAll?'all':'zones';
}
function renderView(){
  const v=currentView();
  $('#builderView').classList.toggle('hidden',v!=='zones');
  $('#catalogView').classList.toggle('hidden',v==='zones');
  renderSidebar(); addPanelCloseControls();
  if(v==='zones')renderZones(); else renderProducts(v);
}
function showAllProducts(on){
  state.showAll=!!on;
  if(!on){state.group='All';}
  saveState(); renderView();
  if(!on)window.scrollTo({top:0});
  const m=$('#main'); if(m)m.scrollTop=0;
}
function flashCart(){$('#cartBtn').animate([{transform:'scale(1)'},{transform:'scale(1.07)'},{transform:'scale(1)'}],{duration:300});}
function openRail(){$('#rail').classList.add('open');$('#backdrop').classList.add('show');}
function closeMobilePanels(){$('#rail').classList.remove('open');$('#side').classList.remove('open');$('#backdrop').classList.remove('show');}
/* Insert after closeMobilePanels in the captured production builder. */
function panelBreakpoint(width){return width<=700?0:width<=840?1:width<=1200?2:3;}
let lastPanelBreakpoint=panelBreakpoint(window.innerWidth);
function reconcileMobilePanels(){
  const width=window.innerWidth, next=panelBreakpoint(width);
  if(next!==lastPanelBreakpoint)closeMobilePanels();
  lastPanelBreakpoint=next;
  if(width<=700||width>840)$('#side').classList.remove('open');
  if(width>1200)$('#rail').classList.remove('open');
  const hasPanel=$('#side').classList.contains('open')||$('#rail').classList.contains('open');
  $('#backdrop').classList.toggle('show',hasPanel&&width<=1200);
}
window.addEventListener('resize',reconcileMobilePanels,{passive:true});
window.addEventListener('pageshow',reconcileMobilePanels);
document.addEventListener('visibilitychange',()=>{if(!document.hidden)reconcileMobilePanels();});
// Touch users can dismiss the full-width kit panel without a keyboard.
function addPanelCloseControls(){
[['#rail .rail-head .rt','Close kit'],['#side','Close menu']].forEach(([selector,label])=>{
  const host=$(selector);if(!host)return;
  if(host.querySelector('.ekb-panel-close'))return;
  const button=document.createElement('button');button.type='button';button.textContent=label;
  button.className='ekb-panel-close';button.setAttribute('aria-label',label);
  button.style.cssText='font-size:11px;background:transparent;border:1px solid #ccc;border-radius:4px;padding:6px 10px;cursor:pointer';
  button.onclick=closeMobilePanels;
  if(selector==='#side')host.prepend(button);else host.appendChild(button);
});
}
addPanelCloseControls();


$('#search').oninput=e=>{state.query=e.target.value;renderView();};
$('#sort').onchange=e=>{state.sort=e.target.value;renderProducts(currentView());};
$('#density').querySelectorAll('button').forEach(b=>b.onclick=()=>{state.density=b.dataset.d;$('#density').querySelectorAll('button').forEach(x=>x.classList.toggle('on',x===b));renderProducts(currentView());});
$('#clearFilters').onclick=()=>{state.group='All';state.sort='featured';$('#sort').value='featured';renderProducts(currentView());};
$('#clearOrder').onclick=()=>clearKit(true);
$('#cartBtn').onclick=()=>{if(window.innerWidth<=1200)openRail();else $('#rail').scrollIntoView({behavior:'smooth'});};
$('#menuBtn').onclick=()=>{$('#side').classList.toggle('open');$('#backdrop').classList.toggle('show');};
$('#backdrop').onclick=closeMobilePanels;
function toggleSearch(force){
  const w=$('#searchWrap'), b=$('#searchBtn');
  const open=force===undefined?!w.classList.contains('open'):force;
  w.classList.toggle('open',open);
  b.setAttribute('aria-expanded',open?'true':'false');
  if(open)$('#search').focus();
  else if(state.query){state.query='';$('#search').value='';}
  renderView();
}
$('#searchBtn').onclick=()=>toggleSearch();
$('#searchClose').onclick=()=>toggleSearch(false);
$('#search').onblur=()=>{setTimeout(()=>{if(isPhone()&&!$('#search').value.trim()&&document.activeElement!==$('#searchClose'))toggleSearch(false);},120);};
$('#skuAdd').onkeydown=e=>{if(e.key==='Enter'&&e.target.value.trim()){quickAddSku(e.target.value);e.target.value='';}};
$('#builderView').querySelectorAll('[data-setup]').forEach(b=>b.onclick=()=>setSetups(state.setups+(+b.dataset.setup)));
$('#setupsHero').onchange=e=>setSetups(+e.target.value||1);
document.addEventListener('keydown',e=>{
  const tag=document.activeElement.tagName;
  if(e.key==='/'&&tag!=='INPUT'&&tag!=='SELECT'&&tag!=='TEXTAREA'){e.preventDefault();$('#search').focus();}
  if(e.key==='Escape'){if(isPhone()&&$('#searchWrap').classList.contains('open'))toggleSearch(false);closeMobilePanels();if(document.activeElement===$('#search')){clearSearch();$('#search').blur();}}
});

/* ---------- init ---------- */
$('#setupsHero').value=state.setups;
renderView();
renderOrder();
resumeAfterContactPost();
if(window.MVPEventKitStartup)window.MVPEventKitStartup.ready();

})();
